module.exports = __webpack_public_path__ + "static/images/wx-2.6127e6c.png";